import { useQuery } from '@tanstack/react-query';
import { getUsersByRolesAPI } from 'src/api';
import { MembershipRole } from 'src/types';

export const useGetUsersByRoles = (roles: MembershipRole[]) => {
  const rolesStringSorted = roles.sort().join('_');

  return useQuery({
    queryKey: ['users-by-roles', rolesStringSorted],
    queryFn: () => getUsersByRolesAPI(rolesStringSorted),
  });
};
